// Libraries
import { IconProps } from '@chakra-ui/react';
// Types
import { RatingKeys } from '@globalTypes/index';

/**
 * Props for the RatingsIcon component.
 */
export type RatingsIconProps = IconProps & {
  /**
   * The rating key, which should be one of the keys defined in the Rating enum.
   */
  rating: RatingKeys | 'N';
  /**
   * Determines if the dark theme should be used.
   */
  dark?: boolean;
  appended?: boolean;
  prepended?: boolean;
};

/**
 * Enumeration representing rating paths.
 */
export enum RatingPaths {
  /**
   * Rating path to display an A.
   */
  A = 'M17.0036 17.606H11.9996L11.1716 20H8.52562L13.0436 7.418H15.9776L20.4956 20H17.8316L17.0036 17.606ZM16.3196 15.59L14.5016 10.334L12.6836 15.59H16.3196Z',
  /**
   * Rating path to display an B.
   */
  B = 'M16.5868 13.556C17.2948 13.688 17.8768 14.042 18.3328 14.618C18.7888 15.194 19.0168 15.854 19.0168 16.598C19.0168 17.27 18.8488 17.864 18.5128 18.38C18.1888 18.884 17.7148 19.28 17.0908 19.568C16.4668 19.856 15.7288 20 14.8768 20H9.4588V7.436H14.6428C15.4948 7.436 16.2268 7.574 16.8388 7.85C17.4628 8.126 17.9308 8.51 18.2428 9.002C18.5668 9.494 18.7288 10.052 18.7288 10.676C18.7288 11.408 18.5308 12.02 18.1348 12.512C17.7508 13.004 17.2348 13.352 16.5868 13.556ZM11.9788 12.62H14.2828C14.8828 12.62 15.3448 12.488 15.6688 12.224C15.9928 11.948 16.1548 11.558 16.1548 11.054C16.1548 10.55 15.9928 10.16 15.6688 9.884C15.3448 9.608 14.8828 9.47 14.2828 9.47H11.9788V12.62ZM14.5168 17.948C15.1288 17.948 15.6028 17.804 15.9388 17.516C16.2868 17.228 16.4608 16.82 16.4608 16.292C16.4608 15.752 16.2808 15.332 15.9208 15.032C15.5608 14.72 15.0748 14.564 14.4628 14.564H11.9788V17.948H14.5168Z',
  /**
   * Rating path to display an C.
   */
  C = 'M7.7218 13.7C7.7218 12.464 7.9978 11.36 8.5498 10.388C9.1138 9.404 9.8758 8.642 10.8358 8.102C11.8078 7.55 12.8938 7.274 14.0938 7.274C15.4978 7.274 16.7278 7.634 17.7838 8.354C18.8398 9.074 19.5778 10.07 19.9978 11.342H17.0998C16.8118 10.742 16.4038 10.292 15.8758 9.992C15.3598 9.692 14.7598 9.542 14.0758 9.542C13.3438 9.542 12.6898 9.716 12.1138 10.064C11.5498 10.4 11.1058 10.88 10.7818 11.504C10.4698 12.128 10.3138 12.86 10.3138 13.7C10.3138 14.528 10.4698 15.26 10.7818 15.896C11.1058 16.52 11.5498 17.006 12.1138 17.354C12.6898 17.69 13.3438 17.858 14.0758 17.858C14.7598 17.858 15.3598 17.708 15.8758 17.408C16.4038 17.096 16.8118 16.64 17.0998 16.04H19.9978C19.5778 17.324 18.8398 18.326 17.7838 19.046C16.7398 19.754 15.5098 20.108 14.0938 20.108C12.8938 20.108 11.8078 19.838 10.8358 19.298C9.8758 18.746 9.1138 17.984 8.5498 17.012C7.9978 16.04 7.7218 14.936 7.7218 13.7Z',
  /**
   * Rating path to display an D.
   */
  D = 'M13.6828 7.436C15.0028 7.436 16.1608 7.694 17.1568 8.21C18.1648 8.726 18.9388 9.464 19.4788 10.424C20.0308 11.372 20.3068 12.476 20.3068 13.736C20.3068 14.996 20.0308 16.1 19.4788 17.048C18.9388 17.984 18.1648 18.71 17.1568 19.226C16.1608 19.742 15.0028 20 13.6828 20H9.29083V7.436H13.6828ZM13.5928 17.858C14.9128 17.858 15.9328 17.498 16.6528 16.778C17.3728 16.058 17.7328 15.044 17.7328 13.736C17.7328 12.428 17.3728 11.408 16.6528 10.676C15.9328 9.932 14.9128 9.56 13.5928 9.56H11.8108V17.858H13.5928Z',
  /**
   * Rating path to display an E.
   */
  E = 'M12.972 9.47V12.62H17.202V14.618H12.972V17.948H17.742V20H10.452V7.418H17.742V9.47H12.972Z',
  /**
   * Rating path to display an N.
   */
  N = '',
}
